import { React } from 'react';
import { TextField, InputAdornment } from "@mui/material";
import { istInteger } from '../../lib'

export default function ZeitraumInput(props) {
  const { value, label, disabled, fullWidth, currency, size } = props;

  function Format(newValue, range) {
    var tmpvalue = newValue
    var neg = 0
    if (negativ) {
      if (tmpvalue.split("-").length - 1 === 1) neg = 1
    }
    tmpvalue = tmpvalue.toString().replace(".", ",")
    tmpvalue = tmpvalue.replace(/,/g, "")
    if (negativ) tmpvalue = tmpvalue.replace(/-/g, "")
    tmpvalue = tmpvalue.replace(/^0+/g, "")

    if (istInteger(tmpvalue) === false) {
      return
    }

    if (tmpvalue.length > 9) {
      return
    }

    if (tmpvalue.length === 0) {
      tmpvalue = "0"
    } else if (tmpvalue.length === 1) {
      tmpvalue = "0.0" + tmpvalue.toString()
    } else if (tmpvalue.length === 2) {
      tmpvalue = "0." + tmpvalue.toString()
    } else if (tmpvalue.length > 2) {
      tmpvalue = tmpvalue.substr(0, tmpvalue.length - 2) + "." + tmpvalue.substr(tmpvalue.length - 2, 2)
    }

    if (neg === 1) tmpvalue = tmpvalue * -1

    if (range) {
      if (Number(tmpvalue) < Number(von)) {
        Format(von)
        return
      }
      if (Number(tmpvalue) > Number(bis)) {
        Format(bis)
        return
      }
    }

    onChange(Number(tmpvalue))
  }

  function checkRange(newValue) {
    if (Number(von) == NaN || Number(bis) == NaN || (Number(von) == 0 && Number(bis) == 0)) return
    Format(newValue, true)
  }

  function getValue() {
    let zeitraum = (value).toString().split(".")
    let tage = zeitraum[0]
    tage = parseInt(tage) < 9 ? "0" + tage : tage

    let stunden = 0
    if (zeitraum[1] === undefined) {
      stunden = "0"
    } else {
      stunden = (Math.floor(("0." + zeitraum[1]) * 24))
    }

    stunden = parseInt(stunden) < 9 ? "0" + stunden : stunden
    return (tage + ":" + stunden)

  }

  return (
    <TextField
      label={label}
      disabled={true}
      size={size ? size : ""}
      fullWidth={fullWidth}
      value={getValue()}
      onChange={(e) => Format(e.target.value)}
      onBlur={(e) => checkRange(e.target.value)}
      InputProps={{
        startAdornment: <InputAdornment position="start">{"Tage:Stunden"}</InputAdornment>,
      }}
    />
  );
}
